import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      // User is authenticated
      return true;
    }

    // User is not authenticated, redirect to login
    this.router.navigate(['/login']);
    return false;
  }
}
